import React, {lazy} from 'react';
import {NOTIFICATION_SETTINGS} from 'shared/account-settings/actions/notification-settings';

const AccountSettings = lazy(() => import('src/components/ChecklistStudentAccountSettings'));
export const UndergraduateAccountSettings = (): React.ReactElement => (
  <AccountSettings availableNotificationSettings={NOTIFICATION_SETTINGS} />
);
